/** Caller-made transaction id for money commands; a retry with the same id is a no-op (content-schemas §11.5). */
export function newTxId(): `tx_${string}` {
  return `tx_${crypto.randomUUID()}`;
}
